var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPreferenceOnboarding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7509 2.44982C11.4509 1.85982 12.5809 1.85982 13.2609 2.44982L14.8409 3.79982C15.1409 4.04982 15.7109 4.25982 16.1109 4.25982H17.8109C18.8709 4.25982 19.7409 5.12982 19.7409 6.18982V7.88982C19.7409 8.28982 19.9509 8.84982 20.2009 9.14982L21.5509 10.7298C22.1409 11.4298 22.1409 12.5598 21.5509 13.2398L20.2009 14.8198C19.9509 15.1198 19.7409 15.6798 19.7409 16.0798V17.7798C19.7409 18.8398 18.8709 19.7098 17.8109 19.7098H16.1109C15.7109 19.7098 15.1509 19.9198 14.8509 20.1698L13.2709 21.5198C12.5709 22.1098 11.4409 22.1098 10.7609 21.5198L9.18086 20.1698C8.88086 19.9198 8.31086 19.7098 7.92086 19.7098H6.17086C5.11086 19.7098 4.24086 18.8398 4.24086 17.7798V16.0698C4.24086 15.6798 4.04086 15.1098 3.79086 14.8198L2.44086 13.2298C1.86086 12.5398 1.86086 11.4198 2.44086 10.7298L3.79086 9.13982C4.04086 8.83982 4.24086 8.27982 4.24086 7.88982V6.19982C4.24086 5.13982 5.11086 4.26982 6.17086 4.26982H7.90086C8.30086 4.26982 8.86086 4.05982 9.16086 3.80982L10.7509 2.44982Z",
    stroke: "#ACB2BD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8.12988V12.9599",
    stroke: "#ACB2BD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9941 16H12.0031",
    stroke: "#ACB2BD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreferenceOnboarding);
export default __webpack_public_path__ + "static/media/preferenceOnboarding.b5bf9d2b52f7ba55280058f99bcfd28a.svg";
export { ForwardRef as ReactComponent };